// SSO and Login page configurations
const enableLogin = process.env.REACT_APP_ENABLE_LOGIN;

let disableLoginPages = process.env.REACT_APP_DISABLE_LOGIN_PAGES;
if (disableLoginPages && typeof disableLoginPages === 'string') {
  disableLoginPages = disableLoginPages.split('|');
}

const enableSSO = process.env.REACT_APP_ENABLE_SSO;

const ssoAuthConfig = {
  ENABLE: enableSSO === 'true',
  SSO_USER_TYPE: 'csr',
  IS_SSO_IDP_INITIATED_FLOW: false,
  SSO_REDIRECT_URL: `${window.location.origin}/ssodone`,
};

const loginMapper = {
  enable: enableLogin === 'true',
  disableLoginPages: disableLoginPages ?? [],
  ssoAuthConfig,
  loginURL: '/auth',
  logoutURL: '/auth/logout',
  refreshURL: '/auth/refresh_token',
  loginMethod: 'jwt',
};

export default loginMapper;
